import React, { useEffect, useState } from "react";
import Home from "./pages/Home";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { fetchMapData, fetchOverviewData } from "@services/dataService";
import {
  selectCurrentYear,
  setOverviewItems,
  setRegions,
} from "@store/mainReducer";

function App() {
  const dispatch = useAppDispatch();
  const currentYear = useAppSelector(selectCurrentYear);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const overviewData = await fetchOverviewData(currentYear);
        dispatch(setOverviewItems(overviewData));

        const mapData = await fetchMapData(currentYear);
        dispatch(setRegions(mapData));

        if (isInitialLoad) {
          setIsInitialLoad(false); // Only set false after first load
        }
      } catch (error) {
        console.error("Error loading data:", error);
        if (isInitialLoad) {
          setIsInitialLoad(false);
        }
      }
    };

    loadData();
  }, [currentYear, dispatch, isInitialLoad]);

  if (isInitialLoad) {
    return <div>Loading...</div>; // Show a loading indicator only on initial load
  }
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
